import React from "react";
import {connect} from "react-redux";
import Calendar from "../../common/Calendar/Calendar";
import Context from "../../../context/Context";
import ChoiceDropdown from "../../common/ChoiceDropdown/ChoiceDropdown";
import MenuOption from "../../common/ChoiceDropdown/MenuOption";
import Rdx from "../../../redux/Rdx";
import * as component from "../../util/component";

const CSS = {
  main: "i-events-datefilter"
};

class DateFilter extends React.Component {

  constructor(props) {
    super(props);
    const optionData = this.makeOptionData();
    this.state = component.newState({optionData: optionData});
    this.clicked = this.clicked.bind(this);
    this.showCalendar = this.showCalendar.bind(this);
  }

  clicked(menuOption) {
    Rdx.setValue(this,Rdx.Keys.EVENTS_DATEFILTER_OPTION,menuOption.props.value);
    Rdx.setValue(this,Rdx.Keys.EVENTS_DATEFILTER_DATESELECTED,null);
    if (this.props.onClick) {
      this.props.onClick("DateFilter",menuOption);
    }
  }

  makeOptionData() {
    const i18n = Context.getInstance().i18n;
    const optionData = [
      {
        label: i18n.events.dateFilter.any,
        value: null
      },
      {
        label: i18n.events.dateFilter.today,
        value: "today"
      },
      {
        label: i18n.events.dateFilter.tomorrow,
        value: "tomorrow"
      },
      {
        label: i18n.events.dateFilter.thisweek,
        value: "thisweek"
      },
      {
        label: i18n.events.dateFilter.thismonth,
        value: "thismonth"
      },
      {
        label: i18n.events.dateFilter.pickdate,
        value: "pickdate",
      }
    ];
    return optionData;
  }

  render() {
    const lib = Context.getInstance().lib;
    const i18n = Context.getInstance().i18n;
    let caption = i18n.events.dateFilter.any;
    let activeValue = this.props.rdxOption;
    if (activeValue === undefined) activeValue = null;
    const optionData = this.state.optionData;
    const options = optionData.map(info => {
      let key = info.key;
      if (key === null) key = "k";
      else key = "k" + info.value;
      let checked = (activeValue === info.value);
      if (checked) caption = info.label;
      if (info.value === "pickdate") {
        if (checked) {
          const date = this.props.rdxDateSelected;
          if (date !== null && date !== undefined) {
            caption = lib.dojo.locale.format(date,{selector:"date",formatLength:"short"});
          }
        }
        return (
          <MenuOption key={key} label={info.label} value={info.value}
            checked={checked} onClick={this.showCalendar} />
        );
      } else {
        return (
          <MenuOption key={key} label={info.label} value={info.value}
            checked={checked} onClick={this.clicked} />
        );
      }
    });
    return (
      <div className={CSS.main}>
        <ChoiceDropdown caption={caption}>
          {options}
        </ChoiceDropdown>
      </div>
    );
  }

  showCalendar(menuOption) {
    const onDateChanged = (date) => {
      if (date !== null && date !== undefined) {
        Rdx.setValue(this,Rdx.Keys.EVENTS_DATEFILTER_OPTION,menuOption.props.value);
        Rdx.setValue(this,Rdx.Keys.EVENTS_DATEFILTER_DATESELECTED,date);
        if (this.props.onClick) {
          this.props.onClick("DateFilter",menuOption,date);
        }
      }
    };
    const initialDate = this.props.rdxDateSelected;
    Calendar.showModal(initialDate,onDateChanged);
  }

}

const mapStateToProps = (state) => {
  return {
    rdxOption: Rdx.getValue(state,Rdx.Keys.EVENTS_DATEFILTER_OPTION),
    rdxDateSelected: Rdx.getValue(state,Rdx.Keys.EVENTS_DATEFILTER_DATESELECTED)
  }
}

export default connect(mapStateToProps)(DateFilter);
